import { useDevice } from "@hooks/useDevice";
/* ----------------- Types --------------- */
import type { Confidence } from "@memorang/types/src/session/common";
import Box from "@memorang/ui/src/components/Box";
import Button from "@memorang/ui/src/components/Button";
import { useTranslation } from "react-i18next";
import { useAIFeedback } from "../hooks/useAIFeedback";

type Props = {
	onConfidenceProvided: (c: Confidence) => void;
	onAiFeedbackProvided: (confidence: Confidence) => void;
};
const SubmitAnswerAIFeedbackButton = ({
	onConfidenceProvided,
	onAiFeedbackProvided,
}: Props) => {
	const { generateExplanation } = useAIFeedback();

	const handleSubmitResponse = async (confidence: Confidence) => {
		onConfidenceProvided(confidence);
		await generateExplanation(() => onAiFeedbackProvided(confidence));
	};

	const { t } = useTranslation();

	const { isMobile } = useDevice();

	return (
		<Box
			style={{
				maxWidth: isMobile ? "100%" : 400,
				width: "100%",
				alignSelf: "center",
			}}
		>
			<Button
				mode="contained"
				onPress={() => {
					handleSubmitResponse(50);
				}}
			>
				{t("common.submitResponse")}
			</Button>
		</Box>
	);
};

export default SubmitAnswerAIFeedbackButton;
